import axios, { AxiosError } from 'axios';

export type SettlementInfoResponse = {
  currency: {
    code: string;
  };
  limits: {
    min: number;
    max: number;
  };
  fee: number;
  rate: number;
  address?: string;
  amount?: number;
  settlementAmount?: number | null;
  hasActiveSettlement: boolean;
  settlementId?: string;
}

export type SettlementCheckRequest = {
  terminalId: string;
  amount: number;
  address: string;
}

export type SettlementCheckResponse = {
  amount: number;
}

export type SettlementCheckError = {
  field: {
    name: string;
    description: string;
  };
}

export type SettlementCreateRequest = {
  terminalId: string;
  address: string;
  amount: number;
}

export type SettlementCreateResponse = {
  settlementId: string;
}

export type SettlementStatusResponse = {
  status: 'DONE' | 'CANCELED' | 'PENDING';
  txId?: string;
  description?: string;
}

export type ManualSettlementCreateRequest = {
  terminalId: string;
  amount: number;
};

export class SettlementApi {
  static readonly KEY = 'settlement';

  static async getSettlementInfo(terminalId: string): Promise<SettlementInfoResponse> {
    const { data } = await axios.get(`/api/v1/settlement?terminalId=${terminalId}`);
    return data.data;
  }

  static async checkSettlement(params: SettlementCheckRequest): Promise<SettlementCheckResponse> {
    const { data } = await axios.post('/api/v1/settlement/check', params);
    return data.data;
  }

  static async createSettlement(params: SettlementCreateRequest): Promise<SettlementCreateResponse> {
    const { data } = await axios.post('/api/v1/settlement', params);
    return data.data;
  }

  static async createManualSettlement(params: ManualSettlementCreateRequest): Promise<void> {
    await axios.post('/api/v1/settlement/manual', params);
  }

  static async getSettlementStatus(terminalId: string, settlementId: string): Promise<SettlementStatusResponse> {
    const { data } = await axios.get(`/api/v1/settlement/status?terminalId=${terminalId}&settlementId=${settlementId}`);
    return data.data;
  }

  static isCheckError(error: unknown): error is AxiosError<{ field: SettlementCheckError['field'] }> {
    return axios.isAxiosError(error) && error.response?.status === 400 && 'field' in (error.response?.data || {});
  }
    static async settlement(params: {
        terminalId: string;
        baseAmount: number;
        settlementAmount: number
    }) {
        const {data} = await axios.post('/api/v1/settlement', params);
        return data;
    }

    static async getStatus(terminalId: string): Promise<SettlementStatusResponse> {
        const {data} = await axios.get(`/api/v1/settlement/status?terminalId=${terminalId}`);
        return data;
    }
}

